import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBase } from '@app/services/base.service';
import { Baixa } from '@app/models/baixa.model';

@Injectable()
export class ReciboMultiploService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  obterRecibos(baixas: Baixa[]): Observable<any> {
    return this.http
      .post<any>(
        this.URL_API + `recibo/gerarListaRecibos`,
        baixas,
      ).pipe(
        catchError((error: any) => observableThrowError(error)));
  }
}
